import { Box } from 'braid-design-system';

export const DataCircle = ({ color }: { color: string }) => (
  <Box
    style={{
      width: '0.5rem',
      height: '0.5rem',
      backgroundColor: color,
      borderRadius: '100%',
    }}
  />
);
